import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PatientRegistrationComponent } from './patient-registration.component';

const routes: Routes = [
    { 
        path: '', 
        component: PatientRegistrationComponent,
    },
    {
        path: ':clinicId',
        component: PatientRegistrationComponent
    },
    { 
        path: ':clinicId/:patientNumber', 
        component: PatientRegistrationComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PatientRegistrationRoutesModule { }
